import React, { useEffect } from "react";
import { Tabs } from "antd";
import { UserOutlined, FileOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import GeneralPanel from "./GeneralPanel";
import ScholarlyOutputPanel from "./ScholarlyOutputPanel";
// import InnovationPanel from "./InnovationPanel";
import SDGPanel from "./SDGPanel";
import { SDGicon } from "../../../assets/svgs/SDG_icons";
import "./setting_page.css";
import { RootState } from "../../../app/store";
import ErrorNotPublic from "../../../components/errors/ErrorNotPublic";
import CreationPanel from "./CreationPanel";
import { useHistory, useParams } from "react-router-dom";
import { RESEARCH_CREATION } from "utils-creation/constants";

const TAB_KEY: Record<string, string> = {
  GENERAL: "general",
  SCHOLARLY_OUTPUT: "scholarly-output",
  // INNOVATION: "innovation",
  RESEARCH_CREATION: RESEARCH_CREATION, // Research Creation for School of Contemporary Arts
  SDG: "sdg",
}

const SettingPage = () => {
  const history = useHistory();
  const { selectedTab } = useParams<{selectedTab: string}>();

  const { user } = useSelector((state: RootState) => state.authentication);

  useEffect(() => {
    if (!Object.keys(TAB_KEY).map(key => TAB_KEY[key]).includes(selectedTab)) {
      history.push(`/settings/${TAB_KEY.GENERAL}`)
    }
  }, [history, selectedTab])

  return user && !user.show_to_public ? (
    <ErrorNotPublic />
  ) : (
    <Tabs
      activeKey={selectedTab}
      onChange={(activeKey) => history.push(`/settings/${activeKey}`)}
    >
      <Tabs.TabPane
        key={TAB_KEY.GENERAL}
        tab={
          <span className="sub-heading-font">
            <UserOutlined />
            General
          </span>
        }
      >
        <GeneralPanel />
      </Tabs.TabPane>

      <Tabs.TabPane
        key={TAB_KEY.SCHOLARLY_OUTPUT}
        tab={
          <span className="sub-heading-font">
            <FileOutlined />
            Scholarly Output
          </span>
        }
      >
        <ScholarlyOutputPanel />
      </Tabs.TabPane>

      {/* <Tabs.TabPane
        key={TAB_KEY.INNOVATION}
        tab={
          <span className="sub-heading-font">
            <FileOutlined />
            Innovation
          </span>
        }
      >
        <InnovationPanel />
      </Tabs.TabPane> */}

      <Tabs.TabPane
        key={TAB_KEY.RESEARCH_CREATION}
        tab={
          <span className="sub-heading-font">
            <FileOutlined />
            Research Creation
          </span>
        }
      >
        <CreationPanel />
      </Tabs.TabPane>

      <Tabs.TabPane
        key={TAB_KEY.SDG}
        tab={
          <span className="sub-heading-font">
            <img
              src={SDGicon}
              alt="SDG"
              height="20"
              style={{ marginRight: 12 }}
            />
            Sustainable Development Goals
          </span>
        }
      >
        <SDGPanel />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default SettingPage;
